// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UcOpv","top":"styles_top__3wo9V","left":"styles_left__3VSbw","description":"styles_description__2SW5d"};